import React from "react";
import TeamFormPage from "../components/team/TeamFormPage";

const TeamCreate = () => <TeamFormPage mode="create" />;

export default TeamCreate;
